export enum MissionType {
  Kamikaze = 'kamikaze',
  CombatMission = 'combat_mission',
  Logistics = 'logistics',
  Rescue = 'rescue',
  MineLaying = 'mine_laying',
  Demining = 'demining',
  CombatEngineering = 'combat_engineering',
  Reconnaissance = 'reconnaissance'
}

export const isMissionLogistical = (missionType: string | undefined) => missionType === MissionType.Logistics;
export const isMissionNonLogistical = (missionType: string | undefined) =>
  !!missionType && missionType !== MissionType.Logistics;

export const isMissionRescue = (missionType: string | undefined) => missionType === MissionType.Rescue;
export const isMissionNonRescue = (missionType: string | undefined) =>
  !!missionType && missionType !== MissionType.Rescue;

export const isMissionKamikaze = (missionType: string | undefined) => missionType === MissionType.Kamikaze;
export const isMissionNonKamikaze = (missionType: string | undefined) =>
  !!missionType && missionType !== MissionType.Kamikaze;

export const isMissionReconnaissance = (missionType: string | undefined) => missionType === MissionType.Reconnaissance;
export const isMissionNonReconnaissance = (missionType: string | undefined) =>
  !!missionType && missionType !== MissionType.Reconnaissance;
